import { useInAppReview } from '../../../../hooks';

export const usePostOrderAppReview = () => {
  const requestInAppReview = useInAppReview();

  return { handlePostOrderAppReview: requestInAppReview };
};
